











import { Component, Mixins } from 'vue-property-decorator';
import { TestimonialFilter } from 'client-website-ts-library/filters';
import { View } from 'client-website-ts-library/plugins';
import { WebsiteLevel } from 'client-website-ts-library/types';

import TestimonialCards from '../components/Testimonials/TestimonialCards.vue';

@Component({
  components: {
    TestimonialCards,
  },
})
export default class Testimonials extends Mixins(View) {
    private filter: TestimonialFilter = new TestimonialFilter({
      SearchLevel: WebsiteLevel.Profile,
      SearchGuid: 'bcf3dba3-b112-4b31-8400-098a71bcbf6c',
    });
}
